<template>
  <v-container>
    <v-layout row wrap class="mb-5">
      <v-flex xs12 md12>
        <v-layout align-center>
          <h1 class="primary--text mr-3">Sectors</h1>
          <v-btn small depressed color="accent" to="/sectors/create">
            <v-icon small>add</v-icon>Add Sector
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line></v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>

    <app-alert
      class="mb-3"
      type="success"
      message="Sector successfully created."
      v-if="$route.query.sectorCreated"
    />
    <!-- <app-alert class="mb-3" type="success" :message="sector.updated" /> -->

    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">
            <span v-if="search !== ''">Results for "{{ search }}"</span>
            <span v-else>All Sectors</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="sectors"
            :loading="isLoading"
            :search="search"
            :rows-per-page-items="[30, 60, 100]"
            no-data-text="No sectors available"
          >
            <template v-slot:items="props">
              <td>{{ (props.index + 1) }}</td>
              <td v-if="sector.editing === props.item._id">
                <v-text-field v-model="sector.cached.name" @input="sector.canSave = true"></v-text-field>
              </td>
              <td v-else>{{ props.item.name }}</td>

              <td v-if="sector.editing === props.item._id">
                <v-select
                  v-model="sector.cached.status"
                  :items="statusOptions"
                  @input="sector.canSave = true"
                ></v-select>
              </td>
              <td v-else>
                <v-chip
                  small
                  :color="props.item.status === 'active' ? 'green' : 'red'"
                  text-color="white"
                >{{ $lang(props.item.status) }}</v-chip>
              </td>

              <td v-if="sector.editing === props.item._id">
                <v-btn
                  small
                  depressed
                  color="success"
                  @click="updateSector()"
                  :disabled="sector.isSaving || !sector.canSave"
                >Save</v-btn>
                <v-btn small flat @click="cancelEdit()" :disabled="sector.isSaving">Cancel</v-btn>
              </td>
              <td v-else>
                <v-icon small class="mr-2" @click="editMode(props.item)">edit</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { SECTOR_FETCH, SECTOR_UPDATE } from '@/store/actions/sector'
import { statusOptions } from '@/data/options'

export default {
  name: 'Sectors',
  created () {
    this.isLoading = true
    this.$store.dispatch(SECTOR_FETCH)
      .finally(() => (this.isLoading = false))
  },
  data () {
    return {
      search: this.$route.query.s || '',
      sector: {
        editing: null,
        cached: null,
        updated: false,
        canSave: false,
        isSaving: false
      },
      isLoading: false,
      statusOptions: statusOptions,
      headers: [
        { text: '#', value: 'index', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  methods: {
    editMode (sector) {
      this.sector.canSave = false
      this.sector.updated = false
      this.sector.editing = sector._id
      this.sector.cached = Object.assign({}, sector)
      delete this.sector.cached.created // removes the created timestamp
      delete this.sector.cached.modified // removes the modified timestamp
    },
    updateSector () {
      if (this.$validator.isRequired(this.sector.cached.name) !== true) return
        
      this.sector.isSaving = true
      this.$store.dispatch(SECTOR_UPDATE, this.sector.cached)
        .then(() => {
          this.sector.updated = 'Sector has been successfully updated.'
        })
        .finally(() => {
          this.sector.canSave = false
          this.sector.editing = null
          this.sector.cached = null
          this.sector.isSaving = false
        })
    },
    cancelEdit () {
      this.sector.canSave = false
      this.sector.editing = null
      this.sector.cached = null
    }
  },
  computed: {
    sectors () {
      return this.$store.getters.sectors
    }
  }
}
</script>
